declare global {
  interface Number {
    formatDistance(): string;
    /**
     * A size in bytes as the reader's language writes it: "1,9 MB" and "700 bayt" in Turkish,
     * "1.9 MB" and "700 byte" in English. Without a locale, the browser's.
     */
    formatFileSize(locale?: string): string;
  }
}

Number.prototype.formatDistance = function (this: number) {
  return this >= 1
    ? this.toFixed(2) + ' M'
    : (this * 100).toFixed(1) + ' CM';
};

// Intl's own units, in the binary steps a file manager counts in (1 KB is 1024 bytes).
const fileSizeUnits = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte'] as const;

Number.prototype.formatFileSize = function (this: number, locale?: string) {
  const step = this > 0 ? Math.min(Math.floor(Math.log(this) / Math.log(1024)), fileSizeUnits.length - 1) : 0;
  // Bytes are whole; the larger units keep one decimal, as Finder and Explorer show them.
  const options: Intl.NumberFormatOptions = {
    style: 'unit', unit: fileSizeUnits[step], unitDisplay: 'short', maximumFractionDigits: step === 0 ? 0 : 1,
  };

  let format: Intl.NumberFormat;
  try {
    format = new Intl.NumberFormat(locale, options);
  } catch {
    // A locale the browser cannot read is no reason to leave a size out.
    format = new Intl.NumberFormat(undefined, options);
  }

  return format.format(this / 1024 ** step);
};

export { };
